// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode-display[data-v-2f267c17]{font-size:.16rem;padding:.05rem .1rem;text-align:center;width:2.1rem}.qrcode-display img[data-v-2f267c17]{width:1.9rem}.qrcode-display-footer[data-v-2f267c17]{display:inline-block}", ""]);
// Exports
module.exports = exports;
